<div class="info-text-payments" role="main" aria-label="Payments page">
    <img src="../assets/images/parking-info.svg" />
    <span [appTranslate]="'INFO_TEXT_PAYMENTS'"></span>
</div>

<div class="filters">
    <div class="searchCard">

        <div class="filter-field">
            <label for="payments-status" [appTranslate]="'STATUS'"></label>
            <select id="payments-status" type="text" name="permit" class="form-control-dropdown " [(ngModel)]="searchModel.PaymentStatus"
                (ngSubmit)="getAllPayments()">
                <option [value]=1><span [appTranslate]="'PAYED'"></span></option>
                <option [value]=0><span [appTranslate]="'NOT_PAYED'"></span></option>
            </select>
        </div>
        <div class="filter-field">
            <div>
                <span [appTranslate]="'DATE_FROM'"> </span> <small *ngIf="InvalidDateFrom"
                    [appTranslate]="'INVALID_DATE'"></small>
            </div>
            <app-mat-datepicker-loc (dateSelected)="onDateSelectedFrom($event)"
                #datepickerFrom></app-mat-datepicker-loc>
        </div>
        <div class="filter-field">
            <div>
                <span [appTranslate]="'DATE_TO'"> </span> <small *ngIf="InvalidDateTo"
                    [appTranslate]="'INVALID_DATE'"></small>
            </div>
            <app-mat-datepicker-loc [minDate]="selectedDateFrom" (dateSelected)="onDateSelectedTo($event)"
                #datepickerTo></app-mat-datepicker-loc>
        </div>

        <!-- <div class="row">

            <div class="div-btn">
                <button type="button" class="round-btn clear" (click)="clearFilter()"><mat-icon aria-hidden="false"
                        fontIcon="refresh"></mat-icon></button>
                <button type="button" class="round-btn search" (click)="getAllPayments()"><mat-icon aria-hidden="false"
                        fontIcon="search"></mat-icon></button>
            </div>
        </div> -->
        <div class="filterBtns">
            <button type="button" class="round-btn clear" (click)="clearFilter()" aria-label="Clear filters">
                <img src="/assets/images/refresh.svg" alt="" aria-hidden="true">
            </button>
            <button type="button" class="round-btn search" (click)="getAllPayments()" aria-label="Search payments">
                <img src="/assets/images/search-normal.svg" alt="" aria-hidden="true">
            </button>
        </div>
    </div>
</div>

<div>
    <h2 [appTranslate]="'PAYMENTS'"></h2>
    <table class="custom-table payment-table">
        <thead>
            <tr>
                <th><span [appTranslate]="'DATE'"></span></th>
                <th><span [appTranslate]="'APPLICATION_ID'"></span></th>
                <th><span [appTranslate]="'ID_NUMBER'"></span></th>
                <th><span [appTranslate]="'STATUS'"></span></th>
                <th><span [appTranslate]="'PRICE'"></span></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of payments">
                <tr (click)="item.expanded = !item.expanded" (keydown.enter)="item.expanded = !item.expanded"
                    (keydown.space)="item.expanded = !item.expanded; $event.preventDefault()"
                    class="row-clickable payment-row" role="button" tabindex="0"
                    [attr.aria-expanded]="item.expanded"
                    [class.is-expanded]="item.expanded">
                    <td *ngIf="item.CasysResponseDate !=null">{{item.CasysResponseDate | date:
                        'dd.MM.YYYY:HH:mm':'mk-MK'}}</td>
                    <td *ngIf="item.CasysResponseDate ==null">{{item.DateCreated | date: 'dd.MM.YYYY HH:mm':'mk-MK'}}
                    </td>
                    <td>{{item.ApplicationId | slice:0:8}}</td>
                    <td>{{item.Id | slice:0:8}}</td>
                    <td *ngIf="item.PaymentStatus"><span class="state paid" [appTranslate]="'PAYED'"></span></td>
                    <td *ngIf="!item.PaymentStatus"><span class="state not-paid" [appTranslate]="'NOT_PAYED'"></span>
                    </td>
                    <td>{{item.Amount}} <span [appTranslate]="'DENARS'"></span></td>
                    <td class="expand-cell">
                        <button type="button" (click)="item.expanded = !item.expanded; $event.stopPropagation()"
                            class="btn btn-acc btn-acc-expand" [attr.aria-expanded]="item.expanded"
                            [attr.aria-controls]="'payment-details-' + item.Id" aria-label="Toggle payment details">
                            <!-- {{ item.expanded ? '−' : '+' }} -->
                            <img src="/assets/images/dropdown.svg" alt="" aria-hidden="true" [class.rotated]="item.expanded">
                        </button>
                    </td>
                </tr>
                <tr *ngIf="item.expanded" class="payment-details-row" [attr.id]="'payment-details-' + item.Id">
                    <td colspan="6">
                        <table class="custom-table mt-0">
                            <thead>
                                <tr>
                                    <th><span [appTranslate]="'VEHICLE_MODEL'"></span></th>
                                    <th><span [appTranslate]="'VEHICLE_REGISTRATION'"></span></th>
                                    <th><span [appTranslate]="'DATE_FROM'"></span></th>
                                    <th><span [appTranslate]="'DATE_TO'"></span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let detail of item.PaymentDetails">
                                    <td>{{detail.Model}}</td>
                                    <td>{{detail.Registration}}</td>
                                    <td>{{detail.DateFrom| date: 'dd.MM.YYYY ':'mk-MK'}}</td>
                                    <td>{{detail.DateTo| date: 'dd.MM.YYYY ':'mk-MK'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </ng-container>
            <!-- <tr *ngFor="let item of payments">
                <td>{{item.CasysResponseDate | date: 'dd.MM.YYYY HH:mm':'mk-MK'}}</td>
                <td>{{item.ApplicationId | slice:0:8}}</td>
                <td>{{item.Id | slice:0:8}}</td>
                <td *ngIf="item.PaymentStatus"><span [appTranslate]="'PAYED'"></span></td>
                <td *ngIf="!item.PaymentStatus"><span [appTranslate]="'NOT_PAYED'"></span></td>
                <td>{{item.Amount}} <span [appTranslate]="'DENARS'"></span></td>
                <div>
                </div>
            </tr> -->
        </tbody>
    </table>
    <div class="no-data" *ngIf="totalPayments==0">
        <small  [appTranslate]="'NO_DATA'"></small>
    </div>
    <div class="text-center" *ngIf="totalPayments != 0">
        <mat-paginator [length]="totalPayments" [pageIndex]="searchModel.Page - 1" [pageSize]="searchModel.Size"
            (page)="pageEvent($event)">
        </mat-paginator>
    </div>
    <div class="clearfix"></div>
</div>


<div class="loader" *ngIf="myLoaderService.isLoading | async"></div>